import { Employee } from 'modules/core/hooks/useCurrentSession'
import hasFeature from 'modules/core/lib/hasFeature'

export const toDateString = (value: unknown): string | undefined => {
  if (value instanceof Date) return value.toISOString().split('T')[0]
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}(T|$)/.test(value)) return value.split('T')[0]
  return undefined
}

export const hasRegularAccessOrNotEmployee = (employee: Employee) =>
  !employee || !hasFeature('employee_onboarding') || employee.hasRegularAccess

export const canAccessWelcomeSpace = (employee: Employee) => {
  if (!employee) {
    return false
  }

  return !employee.isTerminating && !employee.hasRegularAccess && hasFeature('employee_onboarding')
}
